<template>
	<div class="banner-wrapper">
		<div class="sk-widget banner" :style="backgroundStyle">
			<div class="banner-info">
				<slot name="bannerInfo">
					<img :src="avatar" />
					<div class="banner-title-and-subtitle">
						<h1 class="banner-title text-truncate">
							{{ bannerTitle }}
						</h1>
						<div
							class="banner-subtitle"
							v-html="bannerSubtitle"
						></div>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>

<style scoped>
.banner-wrapper {
	margin: 20px 0;
	padding: 0 11px;
	height: 205px;
	max-height: 205px;
}

.banner {
	height: 100%;
	position: relative;
	width: auto;
	margin: 0 auto;
	max-width: 1014px !important;
}

@media only screen and (max-width: 1000px) {
	.banner {
		margin-left: -5px;
		margin-right: -5px;
	}
}

.banner-info {
	height: 71px;
	position: absolute;
	bottom: 0;
	left: 7px;
	right: 7px;
	background: var(--gR-base-80);
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
	display: flex;
	flex-direction: row;
	align-items: left;
}

@media only screen and (max-width: 821px) {
	.banner-info {
		margin-bottom: 1px;
	}
}
@media only screen and (max-width: 750px) {
	.banner-info {
		margin-left: 0px;
		margin-right: 0px;
		margin-bottom: 0px;
	}
}

.banner-title {
	font-size: 18px;
	font-weight: 900;
	margin-bottom: 0;
	color: var(--gR-white);
}

.banner-title-and-subtitle {
	display: flex;
	flex-direction: column;
	height: 71px;
}

.banner-info img {
	margin-right: 15px;
	height: 21px;
}

.banner-subtitle {
	font-size: 12px;
	font-weight: 400;
	color: var(--gR-white);
	padding-bottom: 12px;
}

@media only screen and (max-width: 350px) {
	.banner-subtitle {
		padding-left: 0px;
		margin-top: -4px;
		width: 160px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

@media only screen and (max-width: 650px) {
	.banner-subtitle {
		padding-left: 0px;
		margin-top: -4px;
		white-space: nowrap;
		overflow: hidden;
	}
}

@media only screen and (max-width: 750px) {
	.banner-subtitle {
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
	}
}

@media (max-width: 500px) {
	.banner-wrapper {
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		height: 175px;
		padding: 0;
	}

	.banner {
		border-radius: 0;
	}

	.banner-info {
		left: 18px;
		right: 18px;
	}
}
</style>

<script>
export default {
	name: "Banner",
	props: {
		title: {
			type: String,
			default: null
		},
		subtitle: {
			type: String,
			default: null
		},
		showSubtitle: {
			type: Boolean,
			default: true
		},
		src: String
	},
	computed: {
		backgroundFilePrefix() {
			return `${this.$cdnUrl}${this.$route.params.slug}`
		},
		fallbackAvatar() {
			let imgNameFull = this.$store.state.business.img
			if (!imgNameFull) {
				return ""
			}
			let imgNameArr = imgNameFull.split("-")
			return `${this.backgroundFilePrefix}/${imgNameArr[0]}-logo.jpg`
		},
		avatar() {
			return this.$store.state.business && this.$store.state.business.logo
				? `${this.backgroundFilePrefix}/${this.$store.state.business.logo}`
				: this.fallbackAvatar
		},
		bannerTitle() {
			if (this.title) {
				return this.title
			}
			return this.$store.state.business
				? this.$store.state.business.name
				: ""
		},
		bannerSubtitle() {
			const airportSubtitle = `${"Food made to order, ready in 20 minutes or less!"}`
			if (this.subtitle) {
				return this.subtitle
			} else if (this.$store.state.business.name.includes("Airport")) {
				return airportSubtitle
			}
			return this.$store.getters.businessAddress
		},
		backgroundFileSuffix() {
			if (this.src) {
				return this.src
			}

			let imgNameFull = this.$store.state.business.img
			if (!imgNameFull) {
				return ""
			}
			return (
				process.env.VUE_APP_BASE_IMAGE_URL +
				this.$route.params.slug +
				"/" +
				this.$store.state.business.img
			)
		},
		backgroundStyle() {
			return {
				backgroundImage: `url(${this.backgroundFileSuffix})`,
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover"
			}
		}
	}
}
</script>
